import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
export default function Card(_ref) {
  var id = _ref.id,
      style = _ref.style,
      className = _ref.className,
      children = _ref.children,
      hoverable = _ref.hoverable,
      noShadow = _ref.noShadow;
  return /*#__PURE__*/React.createElement("div", {
    "data-event-container": true,
    id: id,
    style: style,
    className: classNames('jmtd-card', className, {
      'jmtd-card-hoverable': hoverable,
      'jmtd-card-no-shadow': noShadow
    })
  }, children);
}
Card.propTypes = {
  id: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
  hoverable: PropTypes.bool,
  noShadow: PropTypes.bool
};
Card.defaultProps = {
  id: null,
  style: {},
  className: '',
  children: null,
  hoverable: false,
  noShadow: false
};